var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _polygon, _polygon2, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _polygon3, _polygon4, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _polygon5, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgramManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a3d63ade-9d52-45e1-91e7-e418fb2122b3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 946,
    height: 636.54695,
    viewBox: "0 0 946 636.54695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "career development") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.634,733.56808c12.42842,23.049,38.806,32.94351,38.806,32.94351s6.22712-27.47543-6.2013-50.52448-38.806-32.94351-38.806-32.94351S156.20559,710.519,168.634,733.56808Z",
    transform: "translate(-127 -131.72652)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.17653,725.98511c22.43841,13.49969,31.08016,40.3138,31.08016,40.3138s-27.73812,4.92678-50.17653-8.57291S127,717.4122,127,717.4122,154.73811,712.48541,177.17653,725.98511Z",
    transform: "translate(-127 -131.72652)",
    fill: "#71b6fb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 634.54695,
    width: 909,
    height: 2,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 458.20253,
    y: 174.67015,
    width: 75.46311,
    height: 14.79669,
    fill: "#71b6fb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 235.87268,
    width: 75.46311,
    height: 14.79669,
    fill: "#71b6fb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 537.1182,
    y: 346.80494,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 667.82227,
    y: 346.80494,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 736.38026,
    y: 346.80494,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 701.85466,
    y: 459.25977,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 838.97063,
    y: 459.25977,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 804.93825,
    y: 346.80494,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 873.49623,
    y: 346.80494,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "946 266.903 495.194 266.903 495.194 203.277 496.181 203.277 496.181 265.916 946 265.916 946 266.903",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "910.241 380.591 618.589 380.591 618.589 266.594 619.576 266.594 619.576 379.604 910.241 379.604 910.241 380.591",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 555.61406,
    y: 266.65622,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 686.31813,
    y: 266.65622,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 754.87612,
    y: 266.65622,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 823.4341,
    y: 266.65622,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 891.99209,
    y: 266.65622,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 720.35051,
    y: 380.09749,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 857.46649,
    y: 380.09749,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 458.20253,
    y: 299.62708,
    width: 75.46311,
    height: 14.79669,
    fill: "#71b6fb"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 537.1182,
    y: 127.49228,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 667.82227,
    y: 127.49228,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 736.38026,
    y: 127.49228,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 701.85466,
    y: 15.03745,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 838.97063,
    y: 15.03745,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 804.93825,
    y: 127.49228,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 873.49623,
    y: 127.49228,
    width: 37.97816,
    height: 14.79669,
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "946 222.191 495.194 222.191 495.194 285.817 496.181 285.817 496.181 223.178 946 223.178 946 222.191",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "910.241 108.503 618.589 108.503 618.589 222.5 619.576 222.5 619.576 109.49 910.241 109.49 910.241 108.503",
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 555.61406,
    y: 158.87407,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 686.31813,
    y: 158.87407,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 754.87612,
    y: 158.87407,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 823.4341,
    y: 158.87407,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 891.99209,
    y: 158.87407,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 720.35051,
    y: 45.4328,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 857.46649,
    y: 45.4328,
    width: 0.98645,
    height: 63.56362,
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.12972,152.85017c-11.90191-20.11055-35.44888-21.04779-35.44888-21.04779s-22.94519-2.93421-37.66438,27.6944c-13.71946,28.54837-32.65407,56.11241-3.04832,62.79538l5.34766-16.6443,3.31178,17.88345a115.838,115.838,0,0,0,12.6672.21649c31.70536-1.02364,61.89993.29949,60.92772-11.07773C430.93009,197.54567,437.58175,172.20053,426.12972,152.85017Z",
    transform: "translate(-127 -131.72652)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M382.22255,221.3689c.05757,2.26361.04034,4.65094-1.08449,6.61613-2.22988,3.89581-7.67353,4.479-10.9479,7.54954-3.44347,3.2291-3.83323,8.46975-3.99734,13.18755-.17158,4.93244-.31715,10.02652,1.483,14.622a35.54613,35.54613,0,0,0,4.1529,7.13474q2.99868,4.3226,6.05285,8.60636a37.15783,37.15783,0,0,0,3.62433,4.54832c3.64649,3.71441,8.64828,5.77047,13.64245,7.23745,3.22671.9478,6.71072,1.68611,9.91221.65638a18.97688,18.97688,0,0,0,5.76418-3.54439,30.88748,30.88748,0,0,0,6.52463-6.32392c2.6884-3.89974,3.4325-8.78164,3.98976-13.48535a291.00179,291.00179,0,0,0,1.91813-41.92065,10.27431,10.27431,0,0,0-.80034-4.45407c-1.65806-3.23757-6.09888-3.92874-8.43881-6.71366-2.00057-2.381-2.08216-5.7791-2.0651-8.889l.04346-7.917a3.31661,3.31661,0,0,0-.38476-1.92884,3.26772,3.26772,0,0,0-2.271-1.05956,76.55694,76.55694,0,0,0-14.89463-.99647c-4.04195.12351-11.79734-.21481-15.2923,2.03643-3.17236,2.04344.79965,7.68723,1.53447,10.85744A70.73514,70.73514,0,0,1,382.22255,221.3689Z",
    transform: "translate(-127 -131.72652)",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.49042,751.45589c-1.02729,3.49538-1.50409,7.57114.62968,10.5241a10.62817,10.62817,0,0,0,4.49819,3.29469c4.45419,1.93951,9.44009,2.3217,14.293,2.09714a6.74919,6.74919,0,0,0,5.05615-1.94128,62.28775,62.28775,0,0,0,21.5472-36.757,3.48478,3.48478,0,0,0-.11466-2.25538,3.57427,3.57427,0,0,0-1.50088-1.273,33.74457,33.74457,0,0,0-8.04707-3.67473C337.3553,717.46953,320.33,738.39191,316.49042,751.45589Z",
    transform: "translate(-127 -131.72652)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M479.00808,702.47522a22.82094,22.82094,0,0,0,7.53314,5.737,10.57611,10.57611,0,0,0,9.207-.15674c4.26325-2.427,5.47092-8.06663,5.13072-12.96079-.62927-9.05168-4.9532-17.20855-9.92214-24.60269-1.57213-2.33943-5.05234-9.302-8.10668-9.38862-1.45092-.04117-6.87709,5.21963-8.35151,6.22093-5.38666,3.6582-9.11779,6.27552-7.99681,13.29753C467.75216,688.454,473.73742,696.8357,479.00808,702.47522Z",
    transform: "translate(-127 -131.72652)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 44.04695,
    r: 32,
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M378.32317,255.03533a46.813,46.813,0,0,1-4.99051-9.69271,15.73761,15.73761,0,0,1-.08689-10.70389c-3.4579-2.00649-8.15281-.38162-10.671,2.72348s-3.28891,7.26739-3.51093,11.25911.01333,8.04217-.85535,11.94454c-1.92189,8.63371-9.0536,15.73167-9.58394,24.56078-.52175,8.686,5.43453,16.25278,8.36474,24.44623a40.76556,40.76556,0,0,1,2.1839,15.91225c-.09495,1.74208-.20433,3.72756,1.0249,4.96563a5.66348,5.66348,0,0,0,2.21488,1.1933c14.13958,4.97461,29.41239,5.405,44.39673,5.78452l24.74914.62688a7.88806,7.88806,0,0,0,4.37043-.73186c2.22038-1.36141,2.51756-4.41307,2.55531-7.01732.32511-22.42963-.62894-44.85592-1.58277-67.26762-.34572-8.12326-.69731-16.29364-2.4199-24.23969-.43863-2.02337-1.15791-4.27345-3.02578-5.16648-1.58105-.7559-3.45682-.26651-5.10075.34062a40.61431,40.61431,0,0,0-19.02154,14.64248c-5.07821,7.22752-7.57619,15.8975-12.5461,23.17988-3.60662,5.28475-5.6925.679-8.09549-3.21284Q382.50925,261.808,378.32317,255.03533Z",
    transform: "translate(-127 -131.72652)",
    fill: "#71b6fb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M370.12329,225.95847c-1.90429.93594-4.05417,1.34294-5.86658,2.44634-2.1694,1.32073-3.6445,3.50346-5.05062,5.61851l-7.58544,11.40981a35.37556,35.37556,0,0,0-4.34774,7.93829c-1.184,3.46088-1.26447,7.18635-1.37525,10.84248q-.46219,15.25458-1.89593,30.459a109.44616,109.44616,0,0,1-2.10713,14.537c-.90367,3.88709-2.18137,7.67568-3.457,11.45706L324.38279,362.3296a15.74336,15.74336,0,0,0-1.21028,6.5609c.23308,2.23005,1.70872,4.497,3.91542,4.89431a7.68181,7.68181,0,0,0,4.21981-.85335c5.36562-2.24047,10.69154-4.89262,14.82287-8.98429,6.79056-6.72538,9.52177-16.42,11.99247-25.65248,1.31083-4.8983,2.63116-9.86573,2.62584-14.93639-.01209-11.50978-6.80933-22.17028-6.98968-33.67865a58.95823,58.95823,0,0,1,.84214-9.32935c1.21119-8.382,2.46884-16.82785,5.3725-24.78354s7.60467-15.48395,14.51908-20.37434c3.31459-2.34432,12.21525-7.03866,8.73975-12.429C379.76841,217.39039,373.5118,224.29306,370.12329,225.95847Z",
    transform: "translate(-127 -131.72652)",
    fill: "#575a88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M431.77981,329.09754q-34.39767-2.66739-68.85719-4.436c-1.93015-.09906-4.12641-.09533-5.45112,1.312a6.72737,6.72737,0,0,0-1.248,2.34955l-4.90731,13.23453c-2.17384,5.86265-3.16459,11.397-7.50467,15.89807s-9.50384,8.152-13.78865,12.70575a46.86046,46.86046,0,0,0-12.074,24.637c-1.19449,7.5763-.51512,15.42775-2.47282,22.84358-2.41287,9.14006,1.45913,18.65784,1.3984,28.11082-.09044,14.0783-2.02171,28.0724-3.94937,42.0184-5.589,40.43444-11.17809,80.87-17.249,121.23493-4.98427,33.14008-9.89214,68.91415,5.67176,98.59364,3.72,7.09388,8.78707,13.82991,15.90205,17.50941a48.2272,48.2272,0,0,0,12.40569,3.8945,285.16464,285.16464,0,0,0,33.38637,4.945c4.55.40059,9.853.39413,12.771-3.11992,1.9575-2.35738,2.231-5.64212,2.4188-8.70051l1.22641-19.97386c1.587-25.84678,1.00519-52.64253-4.76166-77.88769-1.9444-8.51187-4.39-16.91139-6.01743-25.48951a136.6352,136.6352,0,0,1-2.391-24.713,78.77928,78.77928,0,0,1,1.63042-17.70666c4.2185-18.77156,18.19565-35.69893,16.16345-54.831,12.8792,18.88924,17.14832,40.51553,21.17811,63.0197,2.9395,16.41544,6.11881,32.866,11.68478,48.58632,6.051,17.09029,15.03508,34.058,13.75662,52.14281a68.21194,68.21194,0,0,1-1.8704,11.17175c-3.6591,15.17906,11.80283,28.1599,26.0606,21.79525q.14636-.06532.29222-.13252c13.177-6.07019,19.83246-22.05237,33.27343-27.5132,6.23923-2.53489,14.014-2.8928,16.54224-10.5559a13.45138,13.45138,0,0,0,.553-5.48507c-.59123-6.19771-4.1227-11.21151-6.87142-16.53866-5.996-11.62062-8.26917-24.74714-10.42574-37.64446q-3.21393-19.22078-6.31007-38.461c-1.34942-8.38565-2.69405-16.823-5.45053-24.85683-1.20669-3.51692-2.68109-6.94706-3.64815-10.53727-3.613-13.41324.124-27.70386-1.38654-41.5128-1.69923-15.53336-4.81933-30.958-8.23543-46.206-4.425-19.75149-5.32891-40.10157-6.03995-60.33018-.28243-8.03483-.577-16.267-3.60514-23.71476C449.30855,344.24871,440.882,335.86086,431.77981,329.09754Z",
    transform: "translate(-127 -131.72652)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "293.868 19.185 270.604 6.999 238.479 11.984 231.832 41.341 248.378 40.704 253 29.919 253 40.526 260.634 40.233 265.066 23.062 267.835 41.341 294.976 40.787 293.868 19.185",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M408.63039,240.117a12.99159,12.99159,0,0,1,6.81418-3.38177,3.51653,3.51653,0,0,0,2.40568-.968,3.024,3.024,0,0,0,.40892-1.78589,86.84908,86.84908,0,0,0-1.39716-16.8236,16.917,16.917,0,0,1,6.85326-.93078l21.54076.06027c4.3316.01212,8.81561.05594,12.75707,1.85255a20.29571,20.29571,0,0,1,9.216,9.43648,54.46522,54.46522,0,0,1,4.16639,12.74084c2.56033,11.05458-6.62966,22.18069-7.45132,33.4981-.237,3.26388.03719,6.55205-.263,9.81072-.31608,3.43118-1.26612,6.79689-1.34371,10.24172-.096,4.25968,1.14529,8.43182,2.57591,12.44522,4.371,12.26227,10.59566,23.77146,15.64718,35.76943a29.8614,29.8614,0,0,1,2.57765,8.65042,11.17419,11.17419,0,0,1-2.376,8.48171c-2.10582,2.36341-5.31306,3.32839-8.27068,4.45655a54.13851,54.13851,0,0,0-10.57854,5.43458,22.252,22.252,0,0,1-4.3093,2.49746,27.413,27.413,0,0,1-4.58412,1.01358c-3.99077.75993-7.76038,2.36873-11.61649,3.647-1.27136.42147-2.73821.78926-3.88748.10139a4.68378,4.68378,0,0,1-1.50239-1.78765c-7.39145-12.79963-10.00142-27.75722-11.69581-42.4403s-2.62957-29.60317-7.12415-43.68375c-1.36662-4.28133-3.0621-8.484-3.83872-12.91052-1.12273-6.39924-.28157-13.024-1.43719-19.41739C410.89284,250.45756,408.23943,245.86346,408.63039,240.117Z",
    transform: "translate(-127 -131.72652)",
    fill: "#575a88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M457.746,362.26214c-6.41333,3.06712-11.48663,7.94454-15.77952,13.611-.90879,1.19956.31012,3.43694,3.03357,3.40031,2.53408-.03409,4.048-3.2834,6.582-3.31749a110.0479,110.0479,0,0,0,4.1893,19.9733c5.05554-4.43953,8.08287-10.68905,10.9792-16.76186l5.72523-12.00425c2.1019-4.40711,4.20466-8.81615,6.09931-13.31625a9.607,9.607,0,0,0,.9391-3.35645c.24934-7.74418-7.38593-7.79112-10.67878-2.94457C465.23385,352.84681,464.11214,359.21744,457.746,362.26214Z",
    transform: "translate(-127 -131.72652)",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M459.06272,229.12311c4.89522,5.08652,9.8248,10.21623,13.62491,16.1656s6.44006,12.84723,6.26345,19.90448a18.99,18.99,0,0,0,.194,5.35907,15.27608,15.27608,0,0,0,2.43841,4.51179,85.94233,85.94233,0,0,1,11.04473,22.88978,20.09587,20.09587,0,0,0,1.80753,4.60939c.72285,1.18307,1.70868,2.18216,2.50562,3.31664a12.71612,12.71612,0,0,1,.21769,13.93453,4.67163,4.67163,0,0,0-.86211,1.70016c-.3283,1.94419,2.11168,3.114,3.00892,4.86975.90987,1.78046.03881,4.055-1.47006,5.367a13.6305,13.6305,0,0,1-5.42851,2.42707c2.52442,3.61413-.53932,8.6941-1.56675,12.98117-.719,3-.70985,6.12364-1.18043,9.17245s-1.52912,6.184-3.87752,8.18446a2.42916,2.42916,0,0,1-1.068.59762c-1.30256.25417-2.18986-1.25265-2.64583-2.499-1.41975-3.88071-2.85313-7.83689-5.35632-11.12469s-6.29716-5.86271-10.4294-5.85017a5.56466,5.56466,0,0,1,.40457-5.07777c.828-1.56161,2.04182-2.88507,2.95512-4.39839a20.24232,20.24232,0,0,0,2.32479-6.64437,43.59641,43.59641,0,0,0-5.75625-31.09586,29.77787,29.77787,0,0,0-4.8033-6.00407c-2.01767-1.89084-4.3784-3.411-6.24124-5.45459a21.32534,21.32534,0,0,1-4.96622-12.04978,63.53689,63.53689,0,0,1,.35015-13.21992c.838-8.69706,1.91464-17.40675,3.15691-26.05533a9.71831,9.71831,0,0,1,.86229-3.254C455.54517,230.56711,457.19467,230.00086,459.06272,229.12311Z",
    transform: "translate(-127 -131.72652)",
    fill: "#575a88"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramManager);
export default __webpack_public_path__ + "static/media/program_manager.77aee3c30f01a442304b25317f54116b.svg";
export { ForwardRef as ReactComponent };